module.exports = __webpack_public_path__ + "img/202502_07.111b88ff.jpg";